import { Input } from "@headlessui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import React, { useEffect } from "react";

const OrderSearchInput = ({ status, searchQuery, setSearchQuery, onSearch, darkMode }) => {
    const placeholders = {
        A: "Search Active Orders by...     Customer, Customer Code, Order Number, Product Code, Product Name",
        Arc: "Search Archived Orders by...     Customer, Customer Code, Order Number, Product Code, Product Name",
        ArcP: "Search Plant Archived Orders by...     Sales Rep, Sales Code, Customer, Customer Code, Order Number, Product Code, Product Name",
        P: "Search Pending Orders by...     Customer, Customer Code, Product Code, Product Name",
        Planned: "Search Planned Orders by...     Customer, Customer Code, Product Code, Product Name"
    };

    // Reset search query when status changes
    useEffect(() => {
        setSearchQuery("");
    }, [status, setSearchQuery]);

    return (
        ["A", "P", "Planned", "Arc", "ArcP"].includes(status) && (
            <div className="w-full flex items-center">
                <MagnifyingGlassIcon className="text-gray-600 size-5 mx-6"/>
                <Input
                    className={`tracking-widest ${darkMode ? 'text-white bg-darkMainColor' : 'text-black bg-white'} placeholder:text-xs rounded-md p-1.5 w-full focus:outline-none`}
                    placeholder={placeholders[status] || "Search Orders by Customer"}
                    value={searchQuery}
                    onChange={(e) => onSearch(e.target.value)}
                />
            </div>
        )
    );
};

export default OrderSearchInput;
